import { io } from 'socket.io-client';

export default function socketHandler() {
  const socket = io(process.env.REACT_APP_API_URL || 'http://localhost:3001', {
    auth: {
      token: localStorage.getItem('token'),
    },
    reconnectionAttempts: 1,
    reconnectionDelayMax: 10000,
    timeout: 10000,
  });

  socket.on('connect', async () => {
    console.log('SOCKET CONNECTED');

    const token = localStorage.getItem('token');
    socket.emit('authenticate', token);
  });

  socket.on('disconnect', () => {
    console.log('SOCKET DISCONNECTED');
  });

  return socket;
}
